//
// AbstractMapProvider.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../../../moduleBuilder";
import EventDispatcher from "../../../events/EventDispatcher";
import "../../../lib";
import "../../BaseModel";

var AbstractMapProvider = createModule("commons::AbstractMapProvider", ["commons::PropertyOwner","commons::BaseModel"], EventDispatcher, [
    {
        MAP_PROJECTION_CHANGED: 10000,
    },
    {
        name: 7,
    },
    ,
    ,
    {
        setNeedsInteractiveCoverage: [0,2],
        needsInteractiveCoverage: [2],
    },
    ,
    ,
]);
export default AbstractMapProvider;
